module.exports = __webpack_public_path__ + "static/media/a118.3966c7e9.jpg";